import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, useRoutes } from 'react-router-dom';

import { AuthProvider } from './auth/AuthProvider';
import { ToastHost } from './components/ToastHost';
import { queryClient } from './queryClient';
import { routes } from './routes';

function AppRoutes(): JSX.Element | null {
  return useRoutes(routes);
}

export function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <ToastHost />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
